import { ReactNode } from 'react';
import { Info } from '@phosphor-icons/react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from 'components/ui/tooltip';

interface MetricInfoProps {
  /** Plain-language description, plus formula on a new line. */
  description: ReactNode;
}

/**
 * Small info icon that reveals a tooltip with the metric definition + formula.
 * Use next to KPI labels and chart titles to make calculations transparent.
 */
export const MetricInfo = ({ description }: MetricInfoProps) => {
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Hoe wordt deze metric berekend"
            className="inline-flex items-center text-neutral-secondary-mid hover:text-neutral-primary transition-colors"
          >
            <Info className="h-3.5 w-3.5" weight="duotone" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs leading-relaxed">
          {description}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
